import React from "react";
import { useState, useEffect } from "react";
import { Box, Button, Typography, TextField, Autocomplete } from "@mui/material";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as yup from "yup";
import FormikErrorText from "../components/FormikErrorText";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { colors } from "../theme/Colors";
import AfiaLogo from "../imgs/AfiaLogo.svg";

import { useLocation, useNavigate, useParams } from "react-router-dom";

//imgs
import background from "../imgs/squidGuy4.png";
import background1 from "../imgs/squidGuy5.png";
import squidTitle from "../imgs/squidGameTitle.svg";
import fantasiaLand from "../imgs/fantasialand.svg";
import hacienda from "../imgs/hacienda.svg";
import babezzouar from "../imgs/whitebabezzouar.svg";
import enssea from "../imgs/enssea_white.svg";
import oran_white from "../imgs/Oran_white.svg";
import essania_white from "../imgs/essania_white.svg";
import ferme from "../imgs/ferme.svg";
import afia_white from "../imgs/Sablette_white.svg";
import expoWhite from "../imgs/expoWhite.svg";
import expoBlqck from "../imgs/expoBlack.svg";
import essania from "../imgs/essania.svg";
import x from "../imgs/X.svg";
import gagency from "../imgs/gagency.png";
import fb from "../imgs/fb.svg";
import insta from "../imgs/insta.svg";
import invitation from "../imgs/invitiation.jpg";
import Ticker from "../components/Ticker";
import merino from "../imgs/merino.svg";

//firestore
import db from "../firebase/firebase";
import { collection, addDoc, query, where, getDocs, onSnapshot, serverTimestamp } from "firebase/firestore";

//success
import Success from "./Success";

import axios from "axios";

function Signup() {
  const navigate = useNavigate();

  const events = [
    { key: "Alger", date: "25 juillet 2026", time: "19h00", address: "Fantasia Land", image: fantasiaLand },
    { key: "Blida", date: "01 janvier 2025", time: "16h00", address: "L'Hacienda", image: hacienda },
    { key: "Bab-ezzouar", date: "02 janvier 2025", time: "16h00", address: "Bab-ezzouar", image: babezzouar },
    { key: "Enssea", date: "04 février 2025", time: "14h00", address: "Kolea", image: enssea },
    { key: "Oran", date: "07 février 2025", time: "16h00", address: "Centre Commercial ES-SENIA", image: essania_white },
    { key: "Sablette2", date: "19 juillet 2025", time: "18h00", address: "Les Sablettes - Alger", image: expoWhite },
    { key: "Zeralda", date: "02 janvier 2026", time: "17h00", address: "Ferme pédagogique d'Alger - Zeralda", image: ferme },
  ];

  const location = useLocation();
  const place = location.pathname.slice(1);
  const eventLocation = place.charAt(0).toUpperCase() + place.slice(1).toLowerCase();
  const databaseCount = 1441;
  const eventDate = events.find((event) => event.key === eventLocation).date;
  const eventTime = events.find((event) => event.key === eventLocation).time;
  const eventAddress = events.find((event) => event.key === eventLocation).address;
  const eventImage = events.find((event) => event.key === eventLocation).image;

  console.log("event address", eventAddress);
  console.log("event date", eventDate);

  // const [selectedWilaya, setSelectedWilaya] = useState();
  // const [searchedWilaya, setSearchedWilaya] = useState();

  const [countParticipants, setCountParticipants] = useState();
  const [loading, setLoading] = useState(false);
  const [didSubmit, setDidSubmit] = useState(false);

  //wilayas
  const wilayas = [
    { id: "1", name: "Adrar" },
    { id: "2", name: "Chlef" },
    { id: "3", name: "Laghouat" },
    { id: "4", name: "Oum El Bouaghi" },
    { id: "5", name: "Batna" },
    { id: "6", name: "Béjaïa" },
    { id: "7", name: "Biskra" },
    { id: "8", name: "Bechar" },
    { id: "9", name: "Blida" },
    { id: "10", name: "Bouira" },
    { id: "11", name: "Tamanrasset" },
    { id: "12", name: "Tbessa" },
    { id: "13", name: "Tlemcen" },
    { id: "14", name: "Tiaret" },
    { id: "15", name: "Tizi Ouzou" },
    { id: "16", name: "Alger" },
    { id: "17", name: "Djelfa" },
    { id: "18", name: "Jijel" },
    { id: "19", name: "Se9tif" },
    { id: "20", name: "Saefda" },
    { id: "21", name: "Skikda" },
    { id: "22", name: "Sidi Bel Abbes" },
    { id: "23", name: "Annaba" },
    { id: "24", name: "Guelma" },
    { id: "25", name: "Constantine" },
    { id: "26", name: "Medea" },
    { id: "27", name: "Mostaganem" },
    { id: "28", name: "M'Sila" },
    { id: "29", name: "Mascara" },
    { id: "30", name: "Ouargla" },
    { id: "31", name: "Oran" },
    { id: "32", name: "El Bayadh" },
    { id: "33", name: "Illizi" },
    { id: "34", name: "Bordj Bou Arreridj" },
    { id: "35", name: "Boumerdes" },
    { id: "36", name: "El Tarf" },
    { id: "37", name: "Tindouf" },
    { id: "38", name: "Tissemsilt" },
    { id: "39", name: "El Oued" },
    { id: "40", name: "Khenchela" },
    { id: "41", name: "Souk Ahras" },
    { id: "42", name: "Tipaza" },
    { id: "43", name: "Mila" },
    { id: "44", name: "Ain Defla" },
    { id: "45", name: "Naama" },
    { id: "46", name: "Ain Temouchent" },
    { id: "47", name: "Ghardaefa" },
    { id: "48", name: "Relizane" },
    { id: "49", name: "El M'ghair" },
    { id: "50", name: "El Menia" },
    { id: "51", name: "Ouled Djellal" },
    { id: "52", name: "Bordj Baji Mokhtar" },
    { id: "53", name: "Béni Abbès" },
    { id: "54", name: "Timimoun" },
    { id: "55", name: "Touggourt" },
    { id: "56", name: "Djanet" },
    { id: "57", name: "In Salah" },
    { id: "58", name: "In Guezzam" },
  ];

  //initial values
  const initialValues = {
    lastName: "",
    firstName: "",
    wilaya: null,
    email: "",
    phone: "",
    age: "",
  };

  //validation schema
  const validationSchema = yup.object({
    lastName: yup.string().required("Ce champ est obligatoire"),
    firstName: yup.string().required("Ce champ est obligatoire"),
    wilaya: yup.object().required("Ce champ est obligatoire"),
    email: yup.string().required("Ce champ est obligatoire"),
    phone: yup
      .string()
      .matches(/^\d{10}$/, "Numéro de téléphone invalide")
      .required("Ce champ est obligatoire"),
    age: yup.number().typeError("Ce champ doit être numérique").min(0, "L'âge doit être supérieur ou égal à 0").max(100, "L'âge doit être inférieur ou égal à 100").required("Ce champ est obligatoire"),
  });

  //count number of users
  useEffect(() => {
    const unsub = onSnapshot(collection(db, `${eventLocation}_${databaseCount}`), (snapshot) => {
      setCountParticipants(snapshot?.docs?.length);
    });

    return unsub;
  }, []);

  const checkIfUserExists = async (values) => {
    const q = query(collection(db, `${eventLocation}_${databaseCount}`), where("firstName", "==", values.firstName), where("lastName", "==", values.lastName));

    const querySnapshot = await getDocs(q);
    return !querySnapshot.empty;
  };

  //add new user with email smtp:
  const onSubmit = async (values) => {
    setLoading(true);

    const userExists = await checkIfUserExists(values);

    if (userExists) {
      toast.error("Un utilisateur avec ce nom et prénom existe déjà.", {
        fontSize: "16px",
        position: "top-right",
        autoClose: 15000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        progressStyle: { background: colors.main },
        theme: "colored",
        style: { background: "black" },
      });
      setLoading(false);
      return;
    } else {
      const collectionRef = collection(db, `${eventLocation}_${databaseCount}`);
      await addDoc(collectionRef, { ...values, timestamp: serverTimestamp() });
      navigate("/success", { state: { place: eventAddress, date: eventDate, time: eventTime } });
    }

    // Send confirmation email
    const emailData = {
      sender: { email: "g.agency.dz@gmail.com", name: "SQUID GAME ALGERIE" },
      to: [{ email: values.email, name: `${values?.firstName} ${values?.lastName}` }],
      subject: "Inscription à Squid Game Algérie validée",

      htmlContent: `<div style="width: 100%; max-width: 480px; margin: 0 auto; background-color: white; padding: 16px; border: 1px solid #D9D9D9; border-radius: 10px; display">
        <table style="width: 100%; border-collapse: collapse;">
          <tr>
            <td style="text-align: center; font-weight:500; font-family: Arial, sans-serif; color: #767676; font-size: 24px; padding-bottom: 16px;">Bonjour ${values?.firstName}, Merci pour votre inscription à l'événement SQUID GAME Algérie !</td>
          </tr>
          <tr>
            <td style="text-align: center; font-weight:500; font-family: Arial, sans-serif; color: #767676; font-size: 24px; padding-bottom: 35px;">Veuillez confirmer votre présence 48 heures à l'avance en appelant le</td>
          </tr>
          <tr>
            <td style="text-align: center; padding-bottom: 35px; border-radius: 16px">
              <img src="https://i.ibb.co/XWVxdJZ/invitiation.jpg" alt="G-Agency" style="max-width: 400px%; height: auto; border-radius: 16px; object-fit: cover;" />
            </td>
          </tr>
          <tr>
            <td style="text-align: center; padding-bottom: 30px;">
              <img src="https://i.ibb.co/WvgyM9g/gagency.png" alt="G-Agency" style="width: 60px; height: auto;" />
            </td>
          </tr>
          <tr>
            <td style="text-align: center;">
              <p style="font-family: Arial, sans-serif; color: #767676; font-size: 14px; margin: 0;">
                <a href="mailto:contact@g-agency.dz" style="text-decoration: none; color: #767676;">
                  contact@g-agency.dz
                </a>
              </p>
              <p style="font-family: Arial, sans-serif; color: #767676; font-size: 14px; margin: 0;">+213 559 34 31 38</p>
            </td>
          </tr>
        </table>
      </div>
`,
    };

    const config = {
      headers: {
        "api-key": process.env.REACT_APP_BREVO_API_KEY,
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await axios.post("https://api.sendinblue.com/v3/smtp/email", emailData, config);
      console.log("RESPONSE SEND EMAIL", response);
      toast.success("Votre inscription a été validé avec succès et un email de confirmation a été envoyé.", {
        fontSize: "16px",
        position: "top-right",
        autoClose: 15000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        progressStyle: { background: colors.main },
        theme: "colored",
        style: { background: "black" },
      });
    } catch (error) {
      console.error("Error sending email:", error);
      toast.error("Votre inscription a été validé, mais l'envoi de l'email de confirmation a échoué.", {
        fontSize: "16px",
        position: "top-right",
        autoClose: 15000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        progressStyle: { background: colors.main },
        theme: "colored",
        style: { background: "black" },
      });
    }

    setLoading(false);
  };

  return didSubmit === false ? (
    <Box height="100%" display="flex" justifyContent="center" alignItems="center" sx={{ flexDirection: { lg: "row", xs: "column" } }}>
      <Ticker count={countParticipants} />
      <ToastContainer />
      {/* signup */}
      <Box sx={{ order: { xs: 2, xl: 1 } }} flex={1} display="flex" justifyContent="center" alignItems="center" padding="0.1rem 1rem" marginTop="1rem">
        <Box display="flex" padding="16px" border="1px solid #D9D9D9" borderRadius="10px" flexDirection="column" maxWidth="480px" marginBottom="1rem">
          <Box marginBottom="28px">
            <Typography fontFamily={"NeurialGrotesk-Medium"} fontSize={"14px"} color="#767676">
              Rejoignez nous à{" "}
              <strong style={{ fontFamily: "NeurialGrotesk-Medium", color: "#de3262", fontWeight: "inherit" }}>
                {eventAddress} à {eventTime}
              </strong>{" "}
              pour le défi ultime inspiré de "Squid Game" ! Affrontez des jeux palpitants et testez vos limites. Inscrivez vous maintenant !
            </Typography>
          </Box>

          <Box marginBottom="10px">
            <Typography fontFamily={"AnzeigenGrotesk"} fontSize={"48px"}>
              INSCRIPTION
            </Typography>
          </Box>

          {/* Form */}
          <Box marginBottom="30px">
            <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={validationSchema}>
              {({ setFieldValue }) => (
                <Form>
                  {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
                  <Box display="flex" flexDirection="column" gap="14px">
                    <Box display="flex" flexDirection="row" gap="10px">
                      <Box>
                        <Typography fontFamily={"NeurialGrotesk-Medium"} lineHeight="32px" fontSize="14px" variant="text_xs">
                          Nom
                        </Typography>
                        <Field autoComplete="off" name="lastName" type="text" placeholder="Saisissez votre nom" id="lastName" as={TextField} fullWidth />
                        <ErrorMessage component={FormikErrorText} name="lastName" />
                      </Box>
                      <Box>
                        <Typography fontFamily={"NeurialGrotesk-Medium"} lineHeight="32px" fontSize="14px" variant="text_xs">
                          Prénom
                        </Typography>
                        <Field autoComplete="off" name="firstName" type="text" placeholder="Saisissez votre prénom" id="firstName" as={TextField} fullWidth />
                        <ErrorMessage component={FormikErrorText} name="firstName" />
                      </Box>
                    </Box>

                    <Box>
                      <Typography fontFamily={"NeurialGrotesk-Medium"} lineHeight="32px" fontSize="14px" variant="text_xs">
                        Wilaya
                      </Typography>
                      {/* <Field autoComplete="off" name="email" type="email" placeholder="Saisissez votre Wilaya" id="email" as={TextField} fullWidth /> */}
                      <Box>
                        <Field
                          name="wilaya"
                          as={Autocomplete}
                          options={wilayas}
                          noOptionsText="Aucune option"
                          isOptionEqualToValue={(option, value) => option?.name === value?.name}
                          getOptionLabel={(option) => option?.name || ""}
                          renderInput={(params) => <TextField {...params} fullWidth placeholder="Rechercher une wilaya.." />}
                          onChange={(event, value) => {
                            if (value) {
                              setFieldValue("wilaya", value);
                            }
                            // setSelectedWilaya(value);
                            // console.log("selected wilaya is ::", value);
                            // } else {
                            //   setSelectedWilaya(null);
                            //   setFieldValue("wilaya", null);
                            // }
                          }}
                        />
                        <ErrorMessage component={FormikErrorText} name="wilaya" />
                      </Box>
                    </Box>

                    <Box>
                      <Typography fontFamily={"NeurialGrotesk-Medium"} lineHeight="32px" fontSize="14px" variant="text_xs">
                        Age
                      </Typography>
                      <Field
                        autoComplete="off"
                        name="age"
                        type="text"
                        placeholder="Saisissez votre age"
                        id="age"
                        as={TextField}
                        fullWidth
                        inputProps={{ maxLength: 2 }}
                        onInput={(event) => {
                          const value = event.target.value;
                          if (!/^\d{0,2}$/.test(value)) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage component={FormikErrorText} name="age" />
                    </Box>

                    <Box>
                      <Typography fontFamily={"NeurialGrotesk-Medium"} lineHeight="32px" fontSize="14px" variant="text_xs">
                        Email
                      </Typography>
                      <Field autoComplete="off" name="email" type="email" placeholder="ex : john@doe.com" id="email" as={TextField} fullWidth />
                      <ErrorMessage component={FormikErrorText} name="email" />
                    </Box>

                    <Box>
                      <Typography fontFamily={"NeurialGrotesk-Medium"} lineHeight="32px" fontSize="14px" variant="text_xs">
                        Numéro de téléphone
                      </Typography>
                      <Field autoComplete="off" name="phone" type="phone" placeholder="ex : 05 55 55 55 55" id="phone" as={TextField} fullWidth />
                      <ErrorMessage component={FormikErrorText} name="phone" />
                    </Box>

                    <Box>
                      <Button variant="primary" fullWidth type="submit" disabled={loading}>
                        <Typography fontFamily={"NeurialGrotesk-Regular"}>S'inscrire</Typography>
                      </Button>
                    </Box>
                  </Box>
                </Form>
              )}
            </Formik>
          </Box>
          {/* img */}
          <Box position="relative" flex={1} sx={{ width: "100%", height: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "16px" }}>
            <img style={{ objectFit: "cover", height: "60px" }} src={gagency} alt="G-Agency" />
            <Box display="flex" flexDirection="column" justifyContent="center">
              <Box sx={{ cursor: "pointer" }} onClick={() => (window.location.href = "mailto:contact@g-agency.dz")}>
                <Typography textAlign="center" fontFamily={"NeurialGrotesk-Regular"} fontSize={"14px"} color="#767676">
                  contact@g-agency.dz
                </Typography>
              </Box>
              <Box sx={{ cursor: "pointer" }}>
                <Typography textAlign="center" fontFamily={"NeurialGrotesk-Regular"} fontSize={"14px"} color="#767676">
                  +213 559 34 31 38
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      {/* img */}
      <Box position="relative" flex={1} sx={{ order: { xs: 1, xl: 2 }, width: "100%", height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <img style={{ width: "100%", height: "100vh", objectFit: "cover" }} src={eventAddress === "L'Hacienda" ? background1 : background} alt="squidgame" />
        <Box sx={{ display: "flex", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", backgroundColor: "rgba(142, 142, 142, 0.1)", backdropFilter: "blur(15px)" }} maxWidth="450px" minWidth="350px" padding="16px" borderRadius={"16px"}>
          <Box display="flex" alignItems="center" justifyContent="center" gap="24px" flexDirection="column" width="100%" padding="16px">
            <img style={{ width: "100px" }} src={squidTitle} alt="squidgame-title" />
            <img style={{ width: "30px" }} src={x} alt="x" />
            <img style={{ width: "260px" }} src={eventImage} alt="event-place" />
            {/* <img style={{ width: "260px" }} src={merino} alt="event-place" /> */}
            <Typography color="white" fontSize="16px" fontWeight="800">
              {eventDate} à {eventTime}
            </Typography>
            {eventAddress === "Les Sablettes - Alger" ? (
              <Box textAlign="center" padding="8px" display="flex" gap="16px" flexDirection="column" color="white">
                <Typography>
                  L'age minimaum de participation est de <strong>8 ans.</strong> Les frais de participation <strong>2000 DA</strong> pour les adultes et de <strong>1500 DA</strong> pour les enfants moins de <strong>16 ans.</strong>
                </Typography>

                <Typography>
                  {/* Le vainqueur recevra un trophée et un prix de */}
                  {/* <Typography>
                    <strong style={{ fontSize: "24px" }}> PARTIE GRATUITE !</strong>
                  </Typography> */}
                  Ne manquez pas cette opportunité unique !
                </Typography>
              </Box>
            ) : (
              <Box textAlign="center" padding="8px" display="flex" gap="16px" flexDirection="column" color="white">
                <Typography>
                  L'age minimaum de participation est de <strong>8 ans.</strong> Les frais de participation <strong>2000 DA</strong> pour les adultes et de <strong>1500 DA</strong> pour les enfants moins de <strong>16 ans.</strong>
                </Typography>

                <Typography>
                  Le vainqueur recevra un trophée et un prix de
                  <Typography>
                    <strong style={{ fontSize: "24px" }}>10 000 DA</strong>
                  </Typography>
                  Ne manquez pas cette opportunité unique !
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
        <Box sx={{ display: "flex", position: "absolute", top: "95%", left: "50%", transform: "translate(-50%, -50%)" }} borderRadius={"16px"}>
          <Box display="flex" alignItems="center" justifyContent="center" gap="24px" flexDirection="row" width="100%">
            <Box sx={{ cursor: "pointer" }} onClick={() => window.open("https://web.facebook.com/G.AGENCY.DZ", "_blank")}>
              <img style={{ width: "25px" }} src={fb} alt="facebook" />
            </Box>
            <Box sx={{ cursor: "pointer" }} onClick={() => window.open("https://www.instagram.com/squid_game_algerie", "_blank")}>
              <img style={{ width: "25px" }} src={insta} alt="instagram" />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  ) : (
    <Success />
  );
}

export default Signup;
